<template>
  <HelpContentPage type="2" title-key="TC" section-key="helpTermsSection" />
</template>

<script>
import HelpContentPage from '../components/HelpContentPage'

export default {
  name: 'TermsAndConditionPage',
  components: {HelpContentPage}
}
</script>



// WEBPACK FOOTER //
// src/page/termsAndCondition2.vue